/**
 * 设备类型判断 手机/PC/平板
 */
const os = () => {
  const ua = navigator.userAgent,
    isWindowsPhone = /(?:Windows Phone)/.test(ua),
    isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone,
    isAndroid = /(?:Android|android)/.test(ua),
    isFireFox = /(?:Firefox)/.test(ua),
    isChrome = /(?:Chrome|CriOS)/.test(ua),
    isTablet =
      /(?:iPad|PlayBook)/.test(ua) ||
      (isAndroid && !/(?:Mobile)/.test(ua)) ||
      (isFireFox && /(?:Tablet)/.test(ua)),
    isIPhone = /(?:iPhone)/.test(ua) && !isTablet,
    isAndroidPhone = /(?:Android)/.test(ua) && !isTablet,
    isPc = !isIPhone && !isAndroidPhone && !isSymbian,
    isNioBrowser = /(?:NioBrowser)/.test(ua),
    isIpad =
      /(?:iPad)/.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1),
    isIos = /(?:iphone|ios)/.test(ua.toLowerCase()),
    isMobileDevice =
      /(?:Android|iPhone|iPad|iPod)/.test(ua) && typeof window.orientation !== 'undefined',
    isVertical = document.documentElement.clientWidth / document.documentElement.clientHeight < 1

  return {
    isTablet: isTablet,
    isPhone: isIPhone || isAndroidPhone,
    isPc: isPc,
    isIPhone: isIPhone,
    isNioBrowser: isNioBrowser,
    isIpad: isIpad,
    isAndroid: isAndroid,
    isIos: isIos,
    isMobileDevice: isMobileDevice,
    isVertical: isVertical,
  }
}

export const OS = os()
